import PhonePreviewCampaign from './PhonePreviewCampaign';
import './PhonePreviewCampaign.css';

export default PhonePreviewCampaign;


// WEBPACK FOOTER //
// ./src/routes/PhonePreviewCampaign/index.js